/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertyStatusEnum } from './propertyStatusEnum';


export interface PropertyStatusRequest { 
    status: PropertyStatusEnum;
}
export namespace PropertyStatusRequest {
}


